import Base from './Base'

class TrackService extends Base {
  find(postData) {
    return this.post('track/search_user_track', postData, { noEmpty: true })
  }

  queryTrackDetail(trackId) {
    return this.post('track/query_track_by_id', { trackId })
  }

  saveTrack(postData) {
    return this.post('track/save_track', postData)
  }

  saveAiTrack(postData) {
    return this.post('track/ai_save_track', postData)
  }

  exportAllData(postData) {
    return this.post('track/download', postData, { noEmpty: true })
  }

  // 授权歌单
  querySettlementData(postData) {
    return this.post('settlement/query_settlement_data', postData, { noEmpty: true })
  }

  exportAllSettlementData(postData) {
    return this.post('settlement/download_settlement_data', postData, { noEmpty: true })
  }

  queryAITrackList(postData) {
    return this.post('track/ai_query_track', postData, { noEmpty: true })
  }

  // end
}

export default new TrackService()
